import type React from "react";
import { forwardRef } from "react";
import type {
  IStreamData,
  IThumbnailTemplate,
} from "../../../../../types/thumbnail-template";
import FuneralTemplate from "./FuneralTemplate";
import ConferenceTemplate from "./ConferenceTemplate";

interface TemplateRendererProps {
  streamData: IStreamData;
  template: IThumbnailTemplate;
  style?: React.CSSProperties;
  customBackground?: string;
}

const TemplateRenderer = forwardRef<HTMLDivElement, TemplateRendererProps>(
  ({ streamData, template, style, customBackground }, ref) => {
    const bookingType = streamData?.bookingData?.booking_type;

    console.log("custom background ", streamData);

    // Render conference template
    if (bookingType === "CONFERENCE" || template.category === "conference") {
      return (
        <ConferenceTemplate
          ref={ref}
          streamData={streamData}
          template={template}
          style={style}
          customBackground={customBackground}
        />
      );
    }

    // Render funeral template (default)
    return (
      <FuneralTemplate
        ref={ref}
        streamData={streamData}
        template={template}
        style={style}
      />
    );
  }
);

TemplateRenderer.displayName = "TemplateRenderer";
export default TemplateRenderer;
